module.exports = __webpack_public_path__ + "static/media/showcase.094c07d7.png";